
import { defineComponent, PropType } from 'vue';
import { MaybeImages } from '@/interfaces/ImageNotAllowed';
import OpenSeaDragonViewer from '@/components/global/OpenSeaDragonViewer.vue';

export default defineComponent({
  components: { OpenSeaDragonViewer },
  props: { images: [Object, String] as PropType<MaybeImages> },
});
